<template>
  <modal title="" width="40" :showModal="showModal" @close-modal="closeModal">
    <div class="">
      <div class="text-center">
        <div class="flex justify-center">
          <img
            src="@/assets/images/ondemand/disconnected 1.svg"
            alt="cancel icon"
            class="mb-3"
          />
        </div>
        <div>
          <p>Are you sure you want to cancel?</p>
        </div>
      </div>

      <div class="py-6 pb-3 w-full">
        <div class="flex items-center">
          <el-select
            filterable
            class="w-full"
            v-model="payload.deliveryStatus"
            @change="getReason"
            placeholder="--Tell us why you’re cancelling--"
          >
            <el-option
              v-for="reason in [
                'Wrong pick-up location',
                'Package not ready',
                'Customer changed mind',
                'On customer request',
                'Other',
              ]"
              :key="reason"
              :label="reason"
              :value="reason"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="py-5" v-if="payload.deliveryStatus == 'Other'">
        <label class="label">Reason for Cancellation.</label>
        <textarea
          v-model="payload.message"
          :disabled="payload.deliveryStatus != 'Other'"
          class="text-area"
          placeholder="Text Area"
        ></textarea>
      </div>
      <div class="my-3">
        <p class="text-sm py-0">
          <span class="text-primary-yellow">*</span>
          Please note that cancellation is only applicable for bookings that are
          yet to commence. MuleEx will refund for cancelled bookings, but will
          charge you a flat cancelation fee of N750.
        </p>
      </div>
      <div class="flex justify-between pt-4">
        <base-button
          text="Go Back"
          background="bg-white"
          border="border border-darkBlue"
          @click="closeModal"
        />
        <base-button
          text="Yes, Cancel"
          :loading="loading"
          @click="cancelBooking"
        />
      </div>
    </div>
    <ConfirmCancellation 
    :showModal="showConfirmCancellationModal"
    @close-modal="showConfirmCancellationModal = false"
    />
  </modal>
</template>

<script>
import ConfirmCancellation from "./BookingActions/ConfirmCancellation.vue";

export default {
  components: { ConfirmCancellation },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    bookingId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showConfirmCancellationModal: false,
      disableText: false,
      loading: false,
      reason: "",
      payload: {
        deliveryStatus: "",
        message: "",
      },
    };
  },
  watch: {
    "payload.message"(val) {
      // console.log(val, this.disableText,'dis be')
      if (val == "others") {
        this.disableText = false;
        // console.log(this.disableText,'dis')
      } else this.disableText = true;
    },
  },
  computed: {
    getMessage() {
      return "j";
    },
    shippingId() {
      return this.$store.getters.latestNewShippingInfo?.id;
    },
  },
  mounted() {
    // alert(this.bookingId)
  },
  methods: {
    getReason(val) {
      console.log(val);
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async cancelBooking() {
      this.loading = true;
      try {
        await this.$_cancelShippment(this.shippingId);
        this.loading = false;
        this.generateToast("Booking cancelled successfully", "success");
        this.$router.push("/active-bookings");
        this.$store.dispatch("saveLatestNewBookinTabNum", 1);
        this.$store.dispatch("saveResetNewBookingState");
        this.showConfirmCancellationModal = true
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
textarea:disabled {
  opacity: 0.5;
}
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
.el-select {
  width: w-full;
}
.text-area {
  display: block;
  width: 100%;
  height: 8rem;
  background: #f6f8f9;
  padding: 1em;
  border: 0.5px solid #9ba0a7;
  border-radius: 3px;
}
</style>
